import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  listAdminsReducer,
  singleAdminReducer,
  createAdminReducer,
  updateAdminReducer,
} from "reducers/adminReducers";
import {
  myListOrdersReducer,
  statsOrdersReducer,
  orderSingleReducer,
  createOrderReducer,
  updateOrderReducer,
  deleteOrderReducer,
  listIncompleteOrdersReducer,
  listApprovedOrdersReducer,
  listShippingOrderReducer,
  listDeliveriesOrdersReducer,
} from "reducers/orderReducers";
import {
  listClientsReducer,
  singleClientReducer,
  createClientReducer,
  updateClientReducer,
  deleteClientReducer,
} from "reducers/clientReducers";
import {
  listUsersReducer,
  singleUserReducer,
  createUserReducer,
  updateUserReducer,
  deleteUserReducer,
} from "reducers/userReducers";
import { listCategoriesReducer } from "reducers/categoryReducers";
import { listAddonsReducer, singleAddonsReducer } from "reducers/addonReducers";
import {
  listCompaniesReducer,
  singleCompaniesReducer,
} from "reducers/companyReducers";
import {
  myListTransactionsReducer,
  statsTransactionsReducer,
  incompleteTransactionsReducer,
  orderTransactionReducer,
  singleTransactionReducer,
  createTransactionReducer,
  mpesaTransactionReducer,
  creditTransactionReducer,
  bankTransferTransactionReducer,
  chequeTransactionReducer,
  updateTransactionReducer,
  deleteTransactionReducer,
} from "reducers/transactionReducers";
import { paymentInfoReducer } from "reducers/infoReducers";
import {
  listPoliciesReducer,
  statsPoliciesReducer,
  searchPoliciesReducer,
  singlePolicyReducer,
  listPoliciesPerCategoryReducer,
} from "reducers/policyReducers";
import {
  listPolicyRequirementsReducer,
  singlePolicyRequirementsReducer,
} from "reducers/policyRequirementReducers";
import {
  listResponsePerClientRequirementsReducer,
  singleResponseRequirementsReducer,
  responseRequirementCreateReducer,
  responseRequirementUpdateReducer,
  responseRequirementDeleteReducer,
} from "reducers/responseRequirementReducers";
import {
  myListClaimReducer,
  statsClaimReducer,
  singleClaimReducer,
  pendingClaimReducer,
  postClaimReducer,
  updateClaimReducer,
  deleteClaimReducer,
} from "reducers/claimReducers";
import {
  listClaimRequirementsReducer,
  singleClaimRequirementsReducer,
} from "reducers/claimRequirementReducers";
import {
  companyStatsReducer,
  statsByAgeReducer,
  statsClientsJoinedPerMonthReducer,
  statsNewOrdersPerMonthReducer,
  polComCatCliTopPerformingReducer,
  overallCompanyStatsReducer,
} from "reducers/statsReducers";

const reducer = combineReducers({
  listAdmins: listAdminsReducer,
  singleAdmin: singleAdminReducer,
  createAdmin: createAdminReducer,
  updateAdmin: updateAdminReducer,
  listPolicies: listPoliciesReducer,
  statsPolicies: statsPoliciesReducer,
  searchPolicies: searchPoliciesReducer,
  singlePolicy: singlePolicyReducer,
  listPoliciesPerCategory: listPoliciesPerCategoryReducer,
  listPolicyRequirements: listPolicyRequirementsReducer,
  singlePolicyRequirements: singlePolicyRequirementsReducer,
  listClients: listClientsReducer,
  singleClient: singleClientReducer,
  createClient: createClientReducer,
  updateClient: updateClientReducer,
  deleteClient: deleteClientReducer,
  listUsers: listUsersReducer,
  singleUser: singleUserReducer,
  createUser: createUserReducer,
  updateUser: updateUserReducer,
  deleteUser: deleteUserReducer,
  listAddons: listAddonsReducer,
  singleAddons: singleAddonsReducer,
  listCategories: listCategoriesReducer,
  listCompanies: listCompaniesReducer,
  singleCompanies: singleCompaniesReducer,
  myListTransactions: myListTransactionsReducer,
  statsTransactions: statsTransactionsReducer,
  incompleteTransactions: incompleteTransactionsReducer,
  orderTransaction: orderTransactionReducer,
  singleTransaction: singleTransactionReducer,
  createTransaction: createTransactionReducer,
  mpesaTransaction: mpesaTransactionReducer,
  creditTransaction: creditTransactionReducer,
  bankTransferTransaction: bankTransferTransactionReducer,
  chequeTransaction: chequeTransactionReducer,
  updateTransaction: updateTransactionReducer,
  deleteTransaction: deleteTransactionReducer,
  paymentInfo: paymentInfoReducer,
  myListOrders: myListOrdersReducer,
  statsOrders: statsOrdersReducer,
  orderSingle: orderSingleReducer,
  createOrder: createOrderReducer,
  updateOrder: updateOrderReducer,
  deleteOrder: deleteOrderReducer,
  listIncompleteOrders: listIncompleteOrdersReducer,
  listApprovedOrders: listApprovedOrdersReducer,
  listShippingOrder: listShippingOrderReducer,
  listDeliveriesOrders: listDeliveriesOrdersReducer,
  myListClaim: myListClaimReducer,
  statsClaim: statsClaimReducer,
  singleClaim: singleClaimReducer,
  pendingClaims: pendingClaimReducer,
  postClaim: postClaimReducer,
  updateClaims: updateClaimReducer,
  deleteClaims: deleteClaimReducer,
  listClaimRequirements: listClaimRequirementsReducer,
  singleClaimRequirements: singleClaimRequirementsReducer,
  listResponsePerClientRequirements: listResponsePerClientRequirementsReducer,
  singleResponseRequirements: singleResponseRequirementsReducer,
  responseRequirementCreate: responseRequirementCreateReducer,
  responseRequirementUpdate: responseRequirementUpdateReducer,
  responseRequirementDelete: responseRequirementDeleteReducer,
  companyStats: companyStatsReducer,
  statsByAge: statsByAgeReducer,
  statsClientsJoinedPerMonth: statsClientsJoinedPerMonthReducer,
  statsNewOrdersPerMonth: statsNewOrdersPerMonthReducer,
  polComCatCliTopPerforming: polComCatCliTopPerformingReducer,
  overallCompanyStats: overallCompanyStatsReducer,
});

const initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
